import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

import { Container } from './Refresh.styled'

import { Empty } from './Empty'
import { Error } from './Error'
import PullToRefresh from 'react-simple-pull-to-refresh'
import { useWindowSize } from '../../utils/hooks'

export type EmptyType = {
  Icon?: React.ComponentType<any>
  label: string
}

interface Props {
  loading: 0 | 1 | -1
  onRefresh?: () => void
  children?: React.ReactNode
  small?: boolean
  empty?: EmptyType
  EmptyComponent?: React.ReactNode
}

export const Refresh = (props: Props): JSX.Element => {
  const { loading, onRefresh, children, empty, small, EmptyComponent } = props

  const { isMobile } = useWindowSize()

  const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault()
    e.stopPropagation()

    onRefresh?.()
  }

  const hasChildren = children
    ? Array.isArray(children)
      ? children.reduce((acc, v) => (v ? v : acc), false)
      : true
    : false

  return (
    <>
      {hasChildren ? (
        isMobile ? (
          <PullToRefresh
            onRefresh={() => Promise.resolve(onRefresh?.())}
            refreshingContent={<CircularProgress size={small ? 20 : 40} color="inherit" />}
            pullingContent={<></>}
          >
            {children as React.ReactElement}
          </PullToRefresh>
        ) : (
          <>{children}</>
        )
      ) : (
        <Container
          className="refresh-container"
          loadingData={loading === 1}
          onClick={loading !== 1 ? onClick : undefined}
        >
          {loading === 1 ? (
            <CircularProgress size={small ? 20 : 40} color="inherit" />
          ) : (
            <>
              {loading === -1 ? (
                <Error small={small} />
              ) : empty ? (
                <Empty {...empty} small={small} />
              ) : EmptyComponent ? (
                EmptyComponent
              ) : null}
            </>
          )}
        </Container>
      )}
    </>
  )
}
